import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=1b984361&"
import script from "./Finish.vue?vue&type=script&lang=js&"
export * from "./Finish.vue?vue&type=script&lang=js&"
import style0 from "./Finish.vue?vue&type=style&index=0&id=1b984361&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports